import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Storage } from '@ionic/storage-angular';

@Injectable()
export class GlobalProvider {
  public chatid: string = '';
  public roomTitle: string = '';
  public socketroom: string = '';
  public role: string = '';
  public chatto: string = '';
  public emojipath: string = '';
  public parentpage: any;

  public notification: boolean = false;
  public userinfo = {};
  public chatuser = {};
  public id: string = '';
  public name: string = '';
  public password: string = '';
  public pushid = '';
  public pushtoken = '';
  public main_page: string = '';
  public notify_page: string = '';
  public pushdev: boolean = false;
  public notify: string = '';
  public chatAnnouncementShown: boolean = false; // Track if chat announcement already displayed
  public chattingState: any = null; // ✅ Store chatting state for seamless reconnection
  public replyingTo: any = null; // ✅ Store reply information for icon picker
  public iconPickerClosed: (() => void) | null = null; // ✅ Callback for when icon picker closes
  public showDeleted: boolean = false; // ✅ Store show deleted messages setting for admin
  public globalLoadingActive: boolean = false; // ✅ Global loading state across all pages
  public globalLoadingComplete: boolean = false; // ✅ Track if initial loading is complete
  public overlayLocked: boolean = false; // ✅ Prevent overlay after initial display
  private initialOverlayShown: boolean = false;

  constructor(private http: HttpClient, public storage: Storage) {
    this.initializeStorage();
  }

  private async initializeStorage() {
    await this.storage.create();

    if (!this.id) {
      let val = await this.storage.get('chatuser');
      if (val) {
        this.chatuser = val;
        this.id = val.id;
        this.name = val.name;
        this.role = val.role;
      }

      let val2 = await this.storage.get('userinfo');
      if (val2) {
        this.userinfo = val2;
        this.id = val2.id;
        this.password = val2.password;
        this.pushid = val2.deviceID;
        this.pushtoken = val2.devtoken;
        this.pushdev = val2.pushdev;
      }
    }
  }

  public activateInitialOverlay(): boolean {
    if (this.overlayLocked || this.initialOverlayShown) {
      return false;
    }

    this.initialOverlayShown = true;
    this.globalLoadingActive = true;
    this.globalLoadingComplete = false;
    return true;
  }

  public completeInitialOverlay(): void {
    this.globalLoadingComplete = true;
    this.globalLoadingActive = false;
    this.overlayLocked = true;
  }
}

	
